import { connect } from 'react-redux';
import storage from 'app/services/storage';
import searchModule from 'app/store/search';
import technologies from 'app/store/technologies';
import TechnologyDetails from './TechnologyDetails.component';

const { searchRequest } = searchModule.actions;
const { requestTechnologies } = technologies.actions;

const mapStateToProps = ({ search }) => ({
  movies: search.movies,
  location: storage.getLocation()
});

const mapDispatchToProps = {
  findMovie: searchRequest,
  getTechnologies: requestTechnologies
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TechnologyDetails);
